import React, { useContext, memo, useEffect, useState } from 'react';
import { NavMenu } from './NavMenu';
import { Container, Typography, Paper, Box, Grid, Button, IconButton } from '@mui/material';
import { RouteSelector } from './RouteSelector';
import { Link } from 'react-router-dom';
import RouteContext from '../contexts/RouteContext';
import StopsContext from '../contexts/StopsContext';
import PWDService from '../utils/apiClient';
import AllRouteDataContext from '../contexts/AllRouteDataContext';
import UserContext from '../contexts/UserContext';
import SignInSignOutButton from "./SignInSignOutButton";
import LoadingBackdrop from './LoadingBackdrop';
import Moment from 'moment';
import { BottomNav } from './BottomNav';
import useAsyncQueue from 'use-async-queue';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { clear } from 'idb-keyval';

//For debugging
// eslint-disable-next-line
import RouteSelectDebug from './RouteSelectDebug';
import { checkPropTypes } from 'prop-types';

// const DebugDisplay = () => {
//     const { containerRoute } = useContext(RouteContext);
//     const { stops } = useContext(StopsContext);

//     let routeNumber = containerRoute.RouteNumber;

//     return (
//         <React.Fragment>
//             <p>Currently selected Route: {routeNumber}</p>
//             <p>Current stops count: {Object.keys(stops).length}</p>
//         </React.Fragment>
//     );
// };

const HomeScreenHeader = (props) => {

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleClickReset = () => {
        //IndexedDB clear everything
        clear();
        //reload to trigger api call
        window.location.reload();
    };

    return (
        <NavMenu>
            <IconButton
                aria-controls="homeMenu"
                aria-haspopup="true"
                edge="start"
                aria-label="menu"
                style={{color: 'white'}}
                onClick={handleClickMenu}
                size="large">
                <MenuIcon />
            </IconButton>
            <Menu
                id="homeMenu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
            >
                <MenuItem onClick={handleClickReset} style={{color: 'red'}}>Refresh RouteSmart</MenuItem>
                <MenuItem>v{process.env.REACT_APP_VERSION}</MenuItem>
            </Menu>
            <Typography sx={{ flexGrow: 1, textAlign: 'center' }} style={{fontSize: '1.1rem'}}>
                {props.title}
            </Typography>
            <SignInSignOutButton />
        </NavMenu>
    );
};

//a simple react function component that just returns styled text. It's a label!
function GreetingLabel(props) {
    return (
        <div style={{marginTop: '125px', marginBottom: '50px' }}>
            <Paper elevation={0}>
                <Typography variant="h4" component="div">
                    <Box>
                        Hello {props.userName}
                    </Box>
                </Typography>
            </Paper>
        </div>
    );
}

const PromtTheUserLabel = memo(props => {
    return (
    <div style={{marginTop: '50px', marginBottom: '50px' }}>
        <Paper elevation={0}>
            <Typography>
                Select your route from the dropdown list
            </Typography>
        </Paper>
    </div>
    );
});

const GoToRouteScreenButton = (props) => {

    if (props.containerRoute === ''){
        return (
            <React.Fragment></React.Fragment>
        );
    }
    if (props.stops){
        if (props.stops.length === 0) {
            return (
                <React.Fragment>Looks like there are no route stops for the selected route</React.Fragment>
            );
        } else {
            return (
                <BottomNav>
                    <Button variant="contained" component={Link} to="/route-stops">Go to Stops</Button>
                </BottomNav>
            );
        }
    } else {
        return (<React.Fragment></React.Fragment>);
    }
};


const DebugAsyncQueue = (props) => {
    const [currentArrayIndex, setCurrentArrayIndex] = useState(0);

    const { stops } = useContext(StopsContext);

    const [cache, setCache] = useState({});

    const inflight = (task) => {
        var inprocess = {
            id: task.id,
            status: 'inflight'
        };
        setCache(inprocess);
        //console.dir(stats);
    };

    const done = async task => {
        const result = await task.result;
        console.log(`finished ${task.id}: ${result}`);
    };

    const drain = () => {
        console.log('all done');
        //console.dir(stats);
    };

    const queue = useAsyncQueue({
        concurrency: 6,
        inflight,
        done,
        drain
    });

    const fetchNextFaDetail = () => {
        const task = {
            id: currentArrayIndex,
            task: () => {
                return PWDService.getFieldActivityDetails(stops[currentArrayIndex].FieldActivityId);
            }
        };
        queue.add(task);
        let incrementor = currentArrayIndex;
        incrementor++;
        setCurrentArrayIndex(incrementor);
    };


    return (
        <div>
            <Button onClick={() => fetchNextFaDetail()}>Fetch {currentArrayIndex}: {stops[currentArrayIndex].FieldActivityId}</Button>
        </div>
    );

};

const HomeGrid = (props) => {
    const { currentUser } = useContext(UserContext);

    return (
        <Box sx={{ flexGrow: 1, height: '90vh'}}>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                >
                <GreetingLabel userName={currentUser} />
                <PromtTheUserLabel />
                <RouteSelector />
                <GoToRouteScreenButton stops={props.stops} containerRoute={props.containerRoute}/>
                {/* <DebugAsyncQueue /> */}
                {/* <DebugDisplay /> */}
                {/* <RouteSelectDebug /> */}
            </Grid>
        </Box>
    );
};

const HomeScreen = () => {

    const { allRoutes, setAllRoutes } = useContext(AllRouteDataContext);
    const { containerRoute, setContainerRoute } = useContext(RouteContext);
    const { stops } = useContext(StopsContext);

    const [loading, setLoading] = useState(true);


    useEffect(() => {
        let today = Moment().format();

        //New plan, just make request for all route data,
        //then build route number list from resulting array, instead of making another request just for route numbers

        const fetchAllRouteData = async () => {
            const result = await PWDService.getAllRouteStops();
            return result;
        };
        //check the first item in the allRoutes cache to see if it matches today's date
        let idbRouteOne = allRoutes[0];

        if (idbRouteOne) {
            let existingDate = Moment(idbRouteOne.routeDate).format();
            let sameDayCheck = Moment(existingDate).isSame(today, 'day');

            if (!sameDayCheck) {
                //This is a new day so we need to request fresh data
                console.log("fetching fresh route data");
                //Clear out any old data
                clear().then(() => {
                    //clear whatever was the last route selection
                    setContainerRoute('');

                    fetchAllRouteData().then((value) => {
                        var tempArray = value;
                        //console.log("tempArray: ", tempArray);
                        if (tempArray) {
                            if (Array.isArray(tempArray)) {
                                tempArray.sort((a, b) => a.routeNumber - b.routeNumber);
                                setAllRoutes(tempArray);
                                setLoading(false);
                            } else {
                                //return value likely HTTP status error
                                setLoading(false)
                            }
                        } else {
                            //likely the API is down
                            setLoading(false);
                        }
                    });
                });
            } else {
                //this is the same day so we don't need to download the route data again
                console.log("same day, not downloading route data again");
                setLoading(false);
            }
        } else {
            //The allRoutes idb doesn't exist yet
            console.log("allRoutes idb didn't exist yet, fetching data");
            fetchAllRouteData().then((value) => {
                var tempArray = value;
                //console.log("tempArray: ", tempArray);
                if (tempArray) {
                    if (Array.isArray(tempArray)) {
                        tempArray.sort((a, b) => a.routeNumber - b.routeNumber);
                        setAllRoutes(tempArray);
                        setLoading(false);
                    } else {
                        //return value likely HTTP status error
                        setLoading(false)
                    }
                } else {
                    //likely the API is down
                    setLoading(false);
                }
            });
        }
    },[]);

    if (loading) {
        return (
            <div className="HomeScreen">
                <HomeScreenHeader title="Container Delivery Application" />
                <Container maxWidth={false}>
                    <LoadingBackdrop loading={loading} />
                </Container>
            </div>
        );
    } else {
        return (
            <div className="HomeScreen">
                <HomeScreenHeader title="Container Delivery Application" />
                <Container maxWidth={false}>
                    <HomeGrid stops={stops} containerRoute={containerRoute}/>
                </Container>
            </div>
        );
    }



};

export default HomeScreen;